module.exports = __webpack_public_path__ + "media/images/logos/elp-white-9dd5f113307a9dfc1087442be2c45ae7.svg";